import { AutoCompleteType } from '../../form/auto-complete-type';
import { MemberFormFieldName } from '../types/name';
export const getAutoCompleteType = (name) => {
    switch (name) {
        case MemberFormFieldName.NationalId:
        case MemberFormFieldName.ExternalId:
        case MemberFormFieldName.DateOfBirth: // TODO: For DOB formatting there is another related task #226769
            return AutoCompleteType.Off;
        case MemberFormFieldName.Address:
            return AutoCompleteType.StreetAddress;
        case MemberFormFieldName.State:
            return AutoCompleteType.AddressLevel1;
        case MemberFormFieldName.City:
            return AutoCompleteType.AddressLevel2;
        case MemberFormFieldName.Suburb:
            return AutoCompleteType.AddressLevel3;
        case MemberFormFieldName.FamilyName:
            return AutoCompleteType.FamilyName;
        case MemberFormFieldName.Gender:
            return AutoCompleteType.Sex;
        case MemberFormFieldName.GivenName:
            return AutoCompleteType.GivenName;
        case MemberFormFieldName.HomeNumber:
        case MemberFormFieldName.MobileNumber:
            return AutoCompleteType.Tel;
        case MemberFormFieldName.PostCode:
            return AutoCompleteType.PostalCode;
        default:
            return AutoCompleteType.On;
    }
};
